import { Modal, Row, Col, Form, message } from 'antd';
import TaskForm from '../TaskTypeForm/TaskTypeForm';
import TaskType from '../../../models/TaskType';
import './TaskModal.less';
/**
 * @component TaskModal.tsx
 * @description TaskModal component to add tasks and edit tasks.
 * @return { Component }
 */
interface TaskModalProps {
  isEdit: boolean;
  isHidden: (show: boolean, taskType: TaskType) => void;
  taskType: (taskType: TaskType) => void;
  taskUpdate: any;
}
function TaskModal(props: TaskModalProps) {
  const [form] = Form.useForm();
  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        if (values.color === undefined) {
          message.error('Selecciona un color diferente.');
        } else {
          props.taskType(values);
          props.isHidden(false, {});
          form.resetFields();
        }
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  };
  const handleCancel = () => {
    form.resetFields();
    props.isHidden(false, {});
  };
  const isModal = (modal: boolean, tasktype: TaskType) => {
    props.isHidden(modal, tasktype);
  };

  return (
    <div>
      <Row>
        <Col span={24}>
          <Modal
            title={
              props.isEdit ? 'Editar tipo de tarea' : 'Crear tipo de tarea'
            }
            visible={true}
            onOk={handleOk}
            onCancel={handleCancel}
            okText={props.isEdit ? 'Guardar cambios' : 'Crear tipo de tarea'}
            width={373}
            className={'org-task__modal'}
            cancelText='Cancelar'
          >
            <TaskForm
              form={form}
              isModal={isModal}
              isEdit={props.isEdit}
              taskUpdate={props.taskUpdate}
            />
          </Modal>
        </Col>
      </Row>
    </div>
  );
}

export default TaskModal;
